import React, { forwardRef } from "react";
import { Button, ButtonProps } from "../button";
import { Spinner } from "../spinner/Spinner";

type Props = {
  loading: boolean;
  loadingText?: string | null;
} & React.ComponentProps<typeof Button>;

export const LoadingButton = forwardRef<HTMLButtonElement, Props>(
  ({ loading, loadingText = null, ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        {...(rest as ButtonProps)}
        disabled={rest.disabled ?? loading}
        className={rest.className ?? ""}
      >
        {loading ? (
          <>
            <Spinner size={"sm"} />
            {loadingText}
          </>
        ) : (
          rest.children
        )}
      </Button>
    );
  }
);

LoadingButton.displayName = "LoadingButton";
